var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 12.25V11.0833C11.6663 10.4645 11.4205 9.871 10.9829 9.43342C10.5453 8.99583 9.95185 8.75 9.33301 8.75H4.66634C4.0475 8.75 3.45401 8.99583 3.01643 9.43342C2.57884 9.871 2.33301 10.4645 2.33301 11.0833V12.25M9.33301 4.08333C9.33301 5.372 8.28834 6.41667 6.99967 6.41667C5.71101 6.41667 4.66634 5.372 4.66634 4.08333C4.66634 2.79467 5.71101 1.75 6.99967 1.75C8.28834 1.75 9.33301 2.79467 9.33301 4.08333Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1482f8eba9d0129e8b683235c97561eb.svg";
export { ForwardRef as ReactComponent };